import WheelAnalyticsManager from '../../analytics/WheelAnalyticsManager'
import { tt } from '../../i18n'

export const share = async (url?: string) => {
  WheelAnalyticsManager.logEvent('share')

  if (!url) {
    alert(tt('share_error_no_url'))
    return
  }

  // @ts-ignore
  if (!window.navigator.share) {
    alert(tt('share_error_not_supported'))
    return
  }

  // @ts-ignore{
  await window.navigator.share({ url })
}
